import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import authSliceReducer from "../features/auth/authSlice";
import conversationsSliceReducer from "../features/chat/conversations/conversationsSlice";
import mesagesSliceReducer from "../features/chat/messages/messagesSlice";
import memberSliceReducer from "../features/member/memberSlice";
import menuSliceReducer from "../features/menus/menuSlice";
import tuitionSliceReducer from "../features/tuition/tuitionSlice";
import confirmedTuitionSliceReducer from "../features/tuition/confirmedTuitionSlice";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authSliceReducer,
        conversations: conversationsSliceReducer,
        messages: mesagesSliceReducer,
        menu: menuSliceReducer,
        tuition: tuitionSliceReducer,
        confirmedTuition: confirmedTuitionSliceReducer,
        member: memberSliceReducer,
    },
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddlewares) =>
        getDefaultMiddlewares({
            serializableCheck: false
        }).concat(apiSlice.middleware),
        
});
